import React                              from 'react';
import { ProjectTimelineDateFieldObject } from '@src/services/ProjectService';
import { useProjectMilestone }            from '@src/hooks';


interface ProjectTimelineMilestoneProps<T = never> {field: ProjectTimelineDateFieldObject}

const ProjectTimelineMilestoneDefaultProps = { field: null } satisfies Partial<ProjectTimelineMilestoneProps>

function ProjectTimelineMilestone<T>( p: ProjectTimelineMilestoneProps<T> ){

    const props                    = { ...ProjectTimelineMilestoneDefaultProps, ...p },
          { getTimelineFieldIcon } = useProjectMilestone();


    if( !props.field ){
        return null
    }


    return (
        <>{ getTimelineFieldIcon( props.field ) }</>
    );
}

export {
    ProjectTimelineMilestone,
    ProjectTimelineMilestoneDefaultProps,
    type ProjectTimelineMilestoneProps,
};

